import { render, staticRenderFns } from "./OnlineOrderForm.vue?vue&type=template&id=5894daf8&scoped=true&"
import script from "./OnlineOrderForm.vue?vue&type=script&lang=js&"
export * from "./OnlineOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5894daf8",
  null
  
)

export default component.exports